// Herança dos dados do imóvel (ponto 4 do plano, Sónia, out/2026).
// A proposta e o CPCV recebem os dados do imóvel da angariação (quando a angariação é nossa).
// Os campos herdados ficam bloqueados (🔒) e editam-se na angariação; ao abrir, se a angariação mudou, mostra-se a diferença.
// `prop` = nome do campo na proposta; `k` = nome do campo no imóvel do CPCV; `ang` = nome do campo na angariação.

export const CAMPOS_IMOVEL = [
  { k: "tipo_imovel", ang: "tipo_imovel", prop: "imovel_tipo", rot: "Tipo de imóvel" },
  { k: "tipologia", ang: "tipologia", prop: "imovel_tipologia", rot: "Tipologia" },
  { k: "morada", ang: "morada", prop: "imovel_morada", rot: "Morada" },
  { k: "codigo_postal", ang: "codigo_postal", prop: "imovel_cp", rot: "Código postal" },
  { k: "distrito", ang: "distrito", prop: "imovel_distrito", rot: "Distrito" },
  { k: "concelho", ang: "concelho", prop: "imovel_concelho", rot: "Concelho" },
  { k: "freguesia", ang: "freguesia", prop: "imovel_freguesia", rot: "Freguesia" },
  // só no CPCV
  { k: "artigo_matricial", ang: "artigo_matricial", rot: "Artigo matricial" },
  { k: "fracao", ang: "fracao", rot: "Fração" },
  { k: "descricao_predial", ang: "descricao_predial", rot: "Descrição predial" },
  { k: "licenca_utilizacao", ang: "licenca_numero", rot: "N.º da licença" },
  { k: "licenca_data", ang: "licenca_data", rot: "Licença emitida em" },
  { k: "licenca_cm", ang: "licenca_cm", rot: "Licença da C.M. de" },
];

const vazio = (v) => v === undefined || v === null || String(v).trim() === "";
const igual = (a, b) => String(a ?? "").trim().toLowerCase() === String(b ?? "").trim().toLowerCase();
const campos = (modo) => CAMPOS_IMOVEL.filter((c) => modo === "cpcv" || c.prop);
const chave = (c, modo) => (modo === "cpcv" ? c.k : c.prop);

// a angariação nossa deste processo (pelo id da angariação ou pelo ID do imóvel)
export function angariacaoDe(angariacoes, { angariacaoId, ref } = {}) {
  const lista = angariacoes || [];
  return (angariacaoId && lista.find((a) => a.id === angariacaoId))
    || (ref && lista.find((a) => a.id_angariacao && a.id_angariacao.trim().toLowerCase() === String(ref).trim().toLowerCase()))
    || null;
}

// o campo vem da angariação (e por isso fica bloqueado)?
export const herdado = (ang, chaveDestino, modo) => {
  if (!ang) return false;
  const c = campos(modo).find((x) => chave(x, modo) === chaveDestino);
  return !!c && !vazio(ang[c.ang]);
};

// o que está diferente entre o que está guardado e a angariação de hoje
export function diferencas(destino, ang, modo) {
  if (!ang || !destino) return [];
  return campos(modo)
    .filter((c) => !vazio(ang[c.ang]) && !igual(destino[chave(c, modo)], ang[c.ang]))
    .map((c) => ({ campo: chave(c, modo), rot: c.rot, atual: destino[chave(c, modo)] ?? "", angariacao: ang[c.ang] }));
}

// aplica os dados da angariação (só os campos herdados; o resto fica igual)
export function aplicar(destino, ang, modo) {
  const novo = { ...(destino || {}) };
  if (!ang) return novo;
  campos(modo).forEach((c) => { if (!vazio(ang[c.ang])) novo[chave(c, modo)] = ang[c.ang]; });
  return novo;
}
